import { useSelector } from 'react-redux';
import { useRouteLoaderData } from 'react-router';
import { deepEqual } from '../../../../../common/utils/objectUtils';
import { pendingSubscriptionActionExistsInState } from '../../../../../common/utils/subscriptionUtils';
import { DeviceSubscriptionAddons } from '../../../../../components/SubscriptionDetails/DeviceSubscriptionAddons';
import { DeviceLayout } from '../../../../../components/SubscriptionLayout/DeviceLayout';
import type { DeviceSubscriptionLoaderResponse } from '../../../../../common/loaders';
import type { State } from '../../../../../selfservice/common/store';

export const DeviceAddonsPath = () => {
  const { companyInfo, hasPendingAdminReview, hasPendingActions, subscription } = useRouteLoaderData(
    'deviceSub'
  ) as DeviceSubscriptionLoaderResponse;
  const subscriptionActionsState = useSelector((s: State) => s?.selfservice?.pendingSubscriptionActions, deepEqual);
  return (
    <DeviceLayout companyInfo={companyInfo} subscription={subscription} hasPendingAdminReview={hasPendingAdminReview}>
      <DeviceSubscriptionAddons
        subscription={subscription}
        details={subscription.details}
        hasPendingActions={
          hasPendingActions ||
          pendingSubscriptionActionExistsInState(subscription.subscriptionId, subscriptionActionsState)
        }
      />
    </DeviceLayout>
  );
};
